import { supabase } from './supabase'

/**
 * Saves an update only if no one else changed the record since localUpdatedAt.
 * Returns { data } on success, or { conflict: { serverRecord } } when the
 * record was modified remotely after our local copy was fetched.
 */
export async function saveWithConflictCheck(tableName, recordId, updates, localUpdatedAt) {
  // Fetch the current server version
  const { data: current, error: fetchError } = await supabase
    .from(tableName)
    .select('updated_at')
    .eq('id', recordId)
    .single()

  if (fetchError) throw fetchError

  const serverUpdatedAt = new Date(current.updated_at)
  const localDate = new Date(localUpdatedAt)

  if (serverUpdatedAt > localDate) {
    // Someone else edited — fetch full record for conflict UI
    const { data: serverRecord } = await supabase
      .from(tableName)
      .select('*')
      .eq('id', recordId)
      .single()

    return { conflict: { serverRecord } }
  }

  const { data, error } = await supabase
    .from(tableName)
    .update(updates)
    .eq('id', recordId)
    .select()
    .single()

  if (error) throw error
  return { data }
}
